<div class="page-header">
  <div class="row mx-auto">
    <div class="col align-self-center">{{ title }}</div>
  </div>
</div>
